<div style="display: flex; align-content: center; justify-content: center; width: 100%; margin-top: 100px;">
  @if (!requestSuccess) {
    <mat-card appearance="outlined" style="width: 350px;">
      <mat-card-header>
      @if (this._globals.theme=='light') {
        <img src="/assets/logos/ds_liggande_svart.svg" style="height: 24px; padding: 10px;" />
      }
      @else  {
        <img src="/assets/logos/ds_liggande_vit.svg" style="height: 24px; padding: 10px;" />
      }
      </mat-card-header>
      <mat-card-content>
        <form (ngSubmit)="forgotPassword(UserName.value)" >
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Enter username</mat-label>
            <input matInput type="text" #UserName ngModel name="UserName" placeholder="UserName" required>
            <mat-icon matSuffix>account_box</mat-icon>
          </mat-form-field>
          <br/>
          <br/>
          <button mat-button [disabled]="false"  type="submit">RECOVER PASSWORD</button>
        </form>
      </mat-card-content>
    </mat-card>
  }
  @if (requestSuccess) {
    <div>
      We have sent you an email with instructions how to recover your password.<br/>
      <span style="color:gray">Remember to check spam folder if you can't find the mail in your inbox.</span>
    </div>
  }
  @if (requestError) {
    <div>
      There was an error revocering your password
    </div>
  }

</div>
